const PRODUCT_STATUS_TYPES = {
  PRE_ORDER: 'Preorder',
  REMOVED: 'RemovedItem',
  OUT_OF_STOCK: 'OutOfStock',
  IN_STOCK: 'InStock'
}

const generateProductStatus = (product) => {
  let result;

  if (product?.isPreOrder) {
    result = PRODUCT_STATUS_TYPES.PRE_ORDER;
  } else if (product?.isProductLive) {
    if (product?.isInStock || product?.isProcurable || product?.stockInformation?.isInStock) {
      result = PRODUCT_STATUS_TYPES.IN_STOCK;
    } else {
      result = PRODUCT_STATUS_TYPES.OUT_OF_STOCK;
    }
  } else {
    result = PRODUCT_STATUS_TYPES.REMOVED;
  }

  return result;
}

function capitalizeFirstLetter(string) {
  if (!string) return string;
  return string.charAt(0).toUpperCase() + string.slice(1);
}

const getProductCardDetail = (rawRecommendedProduct, platform = '') => {
  let priceInfo = {
    price: rawRecommendedProduct.price.value,
    originalPrice: rawRecommendedProduct.originalPrice.value,
    discountRate: rawRecommendedProduct.discountRate
  }
  if (rawRecommendedProduct?.campaignPriceInfo?.discountedPrice > 0 && rawRecommendedProduct?.campaignPriceInfo?.discountedPrice !== rawRecommendedProduct.originalPrice.value) {
    priceInfo.discountRate = ((rawRecommendedProduct.originalPrice.value - rawRecommendedProduct?.campaignPriceInfo?.discountedPrice) / rawRecommendedProduct.originalPrice.value) * 100;
  }
  const product = {
    productId: rawRecommendedProduct.productId,
    brand: rawRecommendedProduct.brandName,
    customerReviewRating: rawRecommendedProduct.customerReviewScore,
    customerReviewCount: rawRecommendedProduct.customerReviewCount,
    variantList: [{
      sku: rawRecommendedProduct.sku,
      url: rawRecommendedProduct.productUrl,
      name: rawRecommendedProduct.name,
      images: [{ link: rawRecommendedProduct.imageUrl, isDefault: true }],
      isDefault: true,
      procurable: true,
      campaignPriceInfo: {
        ...rawRecommendedProduct.campaignPriceInfo,
        contentType: capitalizeFirstLetter(rawRecommendedProduct.campaignPriceInfo?.contentType) || '',
      },
      listing: {
        merchantName: rawRecommendedProduct.merchantName,
        isPreOrder: rawRecommendedProduct.isPreOrder,
        listingId: rawRecommendedProduct.listingId,
        merchantId: rawRecommendedProduct.merchantId,
        priceInfo,
        categorizedLabels: rawRecommendedProduct.categorizedLabels,
        campaignPriceInfo: {
          ...rawRecommendedProduct.campaignPriceInfo,
          contentType: capitalizeFirstLetter(rawRecommendedProduct.campaignPriceInfo?.contentType) || '',
          textColor: rawRecommendedProduct.campaignPriceInfo?.color || '',
          discountDetail: {
            rate: priceInfo.discountRate,
          }
        },
        nextEligibleCampaign: {
          ...rawRecommendedProduct?.categorizedLabels?.campaign?.[0] || []
        }
      },
      adInfo: rawRecommendedProduct.adInfo || false
    }],
  }

  return product
}

export {
  generateProductStatus,
  getProductCardDetail
}
